var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "mt-5 mb-5 pt-0" },
        [
          _c(
            "v-sheet",
            { attrs: { color: "mt-5 mb-5 blue lighten-5" } },
            [
              _c(
                "v-row",
                { attrs: { justify: "space-around mt-0 pt-0" } },
                [
                  _c("v-col", { attrs: { cols: "10" } }, [
                    _c("div", { staticClass: " text-center" }, [
                      _c(
                        "label",
                        { staticClass: "font-weight-bold subtitle-1" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "view.contract_form.complete.messages.complete_alert_top"
                              )
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-4" }, [
                      _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "view.contract_form.complete.messages.complete_alert_detail.target_email",
                                { email: _vm.email }
                              )
                            ) +
                            "\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "view.contract_form.complete.messages.complete_alert_detail.after_process"
                              )
                            ) +
                            "\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "view.contract_form.complete.messages.complete_alert_detail.email_setting"
                              )
                            ) +
                            "\n                        "
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bcab867", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bcab867","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contract_form/Complete.vue
// module id = /oVd
// module chunks = 1